// extracted by mini-css-extract-plugin
export default {"block":"SFQ4XjM","fakeOutsideBlock":"rPuvEtz"};